import { Modal, Box, Grid, Typography } from "@mui/material";

import TSPrimaryButton from "../../../../components/common/buttons/TSPrimaryButton";
import TSSecondaryButton from "../../../../components/common/buttons/TSSecondaryButton";

interface DeleteIndexItemModalProps {
  showModal: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

const DeleteIndexItemModal = ({ showModal, onCancel, onDelete }: DeleteIndexItemModalProps) => (
  <Modal
    open={showModal}
    onClose={onCancel}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    sx={{ top: "30%", margin: "auto", maxWidth: "650px" }}
  >
    <Box sx={{ background: "white", maxWidth: "80%", margin: "5% auto", padding: "24px" }}>
      <Typography
        variant="h6"
        sx={{
          color: "rgba(0, 0, 0, 0.87)",
          fontSize: "20px",
          lineHeight: "32px",
          fontWeight: 500,
          marginBottom: "16px",
        }}
      >
        Delete index item
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "rgba(0, 0, 0, 0.87)",
          fontSize: "16px",
          lineHeight: "24px",
          fontWeight: 400,
          marginBottom: "24px",
        }}
      >
        The item will be deleted, this action is not reversible.
      </Typography>

      <Box sx={{ width: "100%", gap: 20 }}>
        <Grid container sx={{ alignContent: "center" }}>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <TSSecondaryButton text="Cancel" onClick={onCancel} styles={{ marginRight: "10px" }} />
            <TSPrimaryButton onClick={onDelete} text="Delete" />
          </Grid>
        </Grid>
      </Box>
    </Box>
  </Modal>
);

export default DeleteIndexItemModal;
